import EpgEvent from '../../classes/epgEvent';
import EventUtils from '../../utils/events';
import { EventMap } from '../../types/interfaces/event';
import { IEventsState } from '../../types/interfaces/states';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IEventsState = {
  currentEvents: {},
  mockedEvents: {},
  eventsData: {},
  currentDateLoaded: false,
  lastModifiedDate: undefined,
  updateRate: undefined,
};

const eventsSlice = createSlice({
  name: 'events',
  initialState,
  reducers: {
    clearEvents: (state) => {
      state.currentEvents = {};
      state.mockedEvents = {};
      state.eventsData = {};
      state.currentDateLoaded = false;
    },
    loadEvents: (
      state,
      action: PayloadAction<{ events: EventMap; purge: boolean }>
    ) => {
      EventUtils.loadEvents(state, action.payload);
    },
    loadMockedEvents: (state, action: PayloadAction<EpgEvent[]>) => {
      EventUtils.loadMocks(state, action.payload);
    },
    updateEvents: (state) => {
      EventUtils.updateEvents(state);
    },
    purgeEvents: (state) => {
      EventUtils.purgeEvents(state);
    },
    setCurrentDateLoaded: (state, action: PayloadAction<boolean>) => {
      state.currentDateLoaded = action.payload;
    },
    setLastModifiedDate: (state, action: PayloadAction<number | undefined>) => {
      state.lastModifiedDate = action.payload;
    },
    setUpdateRate: (state, action: PayloadAction<number | undefined>) => {
      state.updateRate = action.payload;
    },
  },
});

const { actions, reducer: eventsReducer } = eventsSlice;
export const {
  clearEvents,
  loadEvents,
  loadMockedEvents,
  updateEvents,
  purgeEvents,
  setCurrentDateLoaded,
  setLastModifiedDate,
  setUpdateRate,
} = actions;
export const eventsSelector = (state: RootState) => state.events;
export default eventsReducer;
